import { type FunctionReturnType } from "convex/server";
import { api } from "@repo/backend/convex/_generated/api";

/** A public mentor (no private fields), as returned by the Convex queries. */
export type Mentor = FunctionReturnType<typeof api.mentors.getActiveMentors>[number];

export type ExamId = "esat" | "tmua";

/** Fixed service options — kept in sync with the admin form checkboxes. */
export const MENTOR_SERVICES = [
  "1-1 Tutoring",
  "Personal Statement Review",
  "Interview Prep",
  "Application Advice",
] as const;

const CURRENCY_SYMBOLS: Record<string, string> = { GBP: "£", USD: "$", EUR: "€" };

export function formatRate(rate: number, currency: string): string {
  const symbol = CURRENCY_SYMBOLS[currency];
  return symbol ? `${symbol}${rate}/hr` : `${rate} ${currency}/hr`;
}

export function getInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");
}
